(function() {
  'use strict';
  
  // CREATE button if it doesn't exist, then show it - ensure only ONE button shows
  function createOrShowKlaviyoButton(container, productId, variantId) {
    if (!container) return;
    
    var isStickyForm = container.id && container.id.includes('sticky');
    
    // Remove any duplicate fallback buttons (keep only the first one)
    var fallbackButtons = container.querySelectorAll('.klaviyo-bis-trigger');
    if (fallbackButtons.length > 1) {
      for (var i = 1; i < fallbackButtons.length; i++) {
        fallbackButtons[i].remove();
      }
    }
    
    // Check for Klaviyo-injected button first
    var klaviyoInjectedBtn = null;
    var allButtons = container.querySelectorAll('button:not(.klaviyo-bis-trigger), a:not(.klaviyo-bis-trigger)');
    for (var i = 0; i < allButtons.length; i++) {
      var btn = allButtons[i];
      var a11y = btn.getAttribute('data-a11y-identifier') || '';
      if ((btn.id && (btn.id.includes('klaviyo') || btn.id.includes('bis'))) ||
          (btn.className && (btn.className.includes('klaviyo') || btn.className.includes('bis'))) ||
          (btn.getAttribute('data-klaviyo-id')) ||
          (a11y.indexOf('bis-button-') === 0)) {
        klaviyoInjectedBtn = btn;
        break;
      }
    }
    
    var fallbackBtn = container.querySelector('.klaviyo-bis-trigger');
    
    // If Klaviyo button exists, show ONLY it and hide ALL fallbacks
    if (klaviyoInjectedBtn) {
      // Hide ALL other buttons in container first
      allButtons.forEach(function(btn) {
        if (btn !== klaviyoInjectedBtn) {
          btn.style.cssText = 'display: none !important; visibility: hidden !important;';
        }
      });
      
      // Show Klaviyo button
      if (!isStickyForm) {
        klaviyoInjectedBtn.style.cssText = 'display: block !important; visibility: visible !important;';
      } else {
        klaviyoInjectedBtn.classList.add('product-form__add-button', 'button', 'button--primary');
        klaviyoInjectedBtn.style.cssText = 'display: block !important; visibility: visible !important; background-image: none !important; font-size: 14px !important; letter-spacing: .1em !important; line-height: 40px !important; width: 100% !important; min-width: 140px !important; color: #fff !important;';
      }
      
      // Hide ALL fallback buttons
      if (fallbackBtn) {
        fallbackButtons.forEach(function(btn) {
          btn.style.cssText = 'display: none !important; visibility: hidden !important;';
        });
      }
      
      // Update variant ID
      container.setAttribute('data-variant-id', variantId);
      return;
    }
    
    // No Klaviyo button, use fallback - but ensure only ONE
    if (!fallbackBtn) {
      fallbackBtn = document.createElement('button');
      fallbackBtn.type = 'button';
      fallbackBtn.className = 'klaviyo-bis-trigger product-form__add-button button button--primary' + (isStickyForm ? '' : ' button--full');
      fallbackBtn.setAttribute('data-product-id', productId);
      fallbackBtn.setAttribute('data-variant-id', variantId);
      fallbackBtn.textContent = 'Notify me when back in stock';
      container.appendChild(fallbackBtn);
    }
    
    // Hide any Klaviyo-injected buttons if they exist
    allButtons.forEach(function(btn) {
      btn.style.cssText = 'display: none !important; visibility: hidden !important;';
    });
    
    // Update variant ID
    fallbackBtn.setAttribute('data-variant-id', variantId);
    container.setAttribute('data-variant-id', variantId);
    
    // FORCE show fallback
    container.style.cssText = 'display: block !important; visibility: visible !important;';
    fallbackBtn.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;' + (isStickyForm ? ' font-size: 14px !important;' : '');
    
    // Add click handler
    if (!fallbackBtn.hasAttribute('data-handler-added')) {
      fallbackBtn.setAttribute('data-handler-added', 'true');
      fallbackBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var productId = this.getAttribute('data-product-id');

        function findNativeBisButton(pid) {
          var selectors =
            '#klaviyo-bis-button-' + pid + ' button[data-a11y-identifier^="bis-button-"],' +
            '#klaviyo-bis-button-sticky-' + pid + ' button[data-a11y-identifier^="bis-button-"]';
          var candidates = document.querySelectorAll(selectors);
          var visible = null;
          for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].offsetParent !== null) {
              visible = candidates[i];
              break;
            }
          }
          return visible || (candidates.length ? candidates[0] : null);
        }

        var nativeBtn = findNativeBisButton(productId);
        if (nativeBtn) {
          nativeBtn.click();
          return;
        }

        var attempts = 0;
        var maxAttempts = 30;
        var poll = setInterval(function() {
          attempts++;
          var btn = findNativeBisButton(productId);
          if (btn) {
            clearInterval(poll);
            btn.click();
          } else if (attempts >= maxAttempts) {
            clearInterval(poll);
            console.warn('[klaviyo-bis] native Klaviyo BIS button not found for product', productId);
          }
        }, 100);
      });
    }
  }
  
  // ULTRA SIMPLE: Show button when Add to Cart is disabled
  function showKlaviyoButton() {
    try {
      var addToCart = document.getElementById('AddToCart');
      var stickyAddToCart = document.getElementById('StickyAddToCart');
      var containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
      
      // If no containers exist, try to find payment containers and create them
      if (containers.length === 0) {
        var mainPaymentContainer = document.querySelector('.product-form__payment-container');
        var stickyPaymentContainer = document.querySelector('.product-sticky-form__payment-container');
        
        if (mainPaymentContainer && addToCart && (addToCart.disabled || addToCart.classList.contains('button--ternary'))) {
          var form = mainPaymentContainer.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var productId = productIdInput ? productIdInput.value : '';
          
          var container = document.createElement('div');
          container.id = 'klaviyo-bis-button-' + (productId || 'main');
          container.className = 'klaviyo-bis-button-container';
          container.setAttribute('data-product-id', productId);
          mainPaymentContainer.appendChild(container);
          containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
        }
        
        if (stickyPaymentContainer && stickyAddToCart && (stickyAddToCart.disabled || stickyAddToCart.classList.contains('button--ternary'))) {
          var form = stickyPaymentContainer.closest('form') || document.querySelector('form[id*="product-form"]');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var productId = productIdInput ? productIdInput.value : '';
          
          var container = document.createElement('div');
          container.id = 'klaviyo-bis-button-sticky-' + (productId || 'main');
          container.className = 'klaviyo-bis-button-container';
          container.setAttribute('data-product-id', productId);
          stickyPaymentContainer.appendChild(container);
          containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
        }
      }
      
      containers.forEach(function(container) {
        var isMain = container.id.includes('klaviyo-bis-button-') && !container.id.includes('sticky');
        var isSticky = container.id.includes('sticky');
        var button = isMain ? addToCart : (isSticky ? stickyAddToCart : null);
        
        if (!button) return;
        
        var isDisabled = button.disabled || button.classList.contains('button--ternary');
        
        if (isDisabled) {
          // Get product and variant IDs
          var form = button.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
          
          var productId = container.getAttribute('data-product-id') || 
                        (productIdInput ? productIdInput.value : '') ||
                        container.id.replace('klaviyo-bis-button-', '').replace('-sticky', '');
          var variantId = container.getAttribute('data-variant-id') || 
                         (variantIdInput ? variantIdInput.value : '');
          
          // Remove any duplicate buttons first
          var allButtons = container.querySelectorAll('button, a');
          var visibleButtons = [];
          allButtons.forEach(function(btn) {
            if (btn.offsetParent !== null && window.getComputedStyle(btn).display !== 'none') {
              visibleButtons.push(btn);
            }
          });
          
          // If more than one visible button, hide duplicates
          if (visibleButtons.length > 1) {
            // Keep the first one, hide the rest
            for (var i = 1; i < visibleButtons.length; i++) {
              visibleButtons[i].style.cssText = 'display: none !important; visibility: hidden !important;';
            }
          }
          
          // Create or show button (will handle showing only one)
          createOrShowKlaviyoButton(container, productId, variantId);
          
          // Hide Add to Cart
          button.style.setProperty('display', 'none', 'important');
        } else {
          // Hide container, show Add to Cart
          container.style.setProperty('display', 'none', 'important');
          button.style.removeProperty('display');
        }
      });
    } catch(e) {
      // Silently handle errors
    }
  }
  
  // Run immediately and on intervals
  function init() {
    showKlaviyoButton();
    setTimeout(showKlaviyoButton, 100);
    setTimeout(showKlaviyoButton, 500);
    setTimeout(showKlaviyoButton, 1000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Watch for variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(showKlaviyoButton, 100);
  });
  
  // Watch Add to Cart button
  var observer = new MutationObserver(function() {
    showKlaviyoButton();
  });
  
  setTimeout(function() {
    var addToCart = document.getElementById('AddToCart');
    var stickyAddToCart = document.getElementById('StickyAddToCart');
    if (addToCart) observer.observe(addToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
    if (stickyAddToCart) observer.observe(stickyAddToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }, 500);
  
  // Function to update combo-box color swatch disabled states
  function updateComboBoxColorSwatches() {
    // Find all combo-box color swatches in sticky form
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;
    
    // Check all combo-box option items
    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      var colorSwatch = option.querySelector('.combo-box__color-swatch');
      if (!colorSwatch) return;
      
      // Check if the option itself has is-disabled class (added by product-variants component)
      // or is hidden/disabled (indicates out of stock variant)
      var isDisabled = option.classList.contains('is-disabled') ||
                      option.hasAttribute('disabled') ||
                      option.hasAttribute('hidden') ||
                      option.getAttribute('aria-disabled') === 'true';
      
      if (isDisabled) {
        colorSwatch.classList.add('is-disabled');
      } else {
        colorSwatch.classList.remove('is-disabled');
      }
    });
    
    // Also check the selected value display (the toggle button that shows selected option)
    var selectButtons = stickyForm.querySelectorAll('.select[aria-controls*="combo-box"]');
    selectButtons.forEach(function(selectButton) {
      var selectedValueSpan = selectButton.querySelector('.select__selected-value');
      if (selectedValueSpan) {
        var colorSwatch = selectedValueSpan.querySelector('.select__color-swatch');
        if (colorSwatch) {
          // Find the corresponding option item to check if it's disabled
          var comboBoxId = selectButton.getAttribute('aria-controls');
          if (comboBoxId) {
            var comboBox = document.getElementById(comboBoxId);
            if (comboBox) {
              var selectedValue = selectedValueSpan.textContent.trim();
              var optionItems = comboBox.querySelectorAll('.combo-box__option-item');
              optionItems.forEach(function(option) {
                if (option.textContent.trim() === selectedValue || 
                    option.getAttribute('value') === selectedValue) {
                  var isDisabled = option.classList.contains('is-disabled') ||
                                  option.hasAttribute('disabled') ||
                                  option.hasAttribute('hidden') ||
                                  option.getAttribute('aria-disabled') === 'true';
                  
                  if (isDisabled) {
                    colorSwatch.classList.add('is-disabled');
                  } else {
                    colorSwatch.classList.remove('is-disabled');
                  }
                }
              });
            }
          }
        }
      }
    });
  }
  
  
  // Update combo-box color swatches on initial load and interactions
  function initComboBoxObservers() {
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;
    
    // Initial update
    setTimeout(updateComboBoxColorSwatches, 500);
    
    // Watch for changes to is-disabled class on combo-box options
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'aria-disabled' || mutation.attributeName === 'disabled' || mutation.attributeName === 'hidden')) {
          updateComboBoxColorSwatches();
        }
      });
    });
    
    // Observe all combo-box option items
    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      observer.observe(option, {
        attributes: true,
        attributeFilter: ['class', 'aria-disabled', 'disabled', 'hidden']
      });
    });
    
    // Observe combo-box containers for new option items
    var comboBoxes = stickyForm.querySelectorAll('.combo-box');
    comboBoxes.forEach(function(comboBox) {
      observer.observe(comboBox, {
        childList: true,
        subtree: true
      });
    });
    
    // Watch for combo-box toggle state changes
    var comboBoxToggleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          var toggleButton = mutation.target;
          if (toggleButton.getAttribute('aria-expanded') === 'false' && 
              toggleButton.closest('.product-sticky-form')) {
            setTimeout(updateComboBoxColorSwatches, 100);
          }
        }
      });
    });
    
    var toggleButtons = stickyForm.querySelectorAll('[is="toggle-button"][aria-controls*="combo-box"]');
    toggleButtons.forEach(function(button) {
      comboBoxToggleObserver.observe(button, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  }
  
  // Update on combo-box interactions
  document.addEventListener('click', function(e) {
    if (e.target.closest('.combo-box__option-item') || 
        e.target.closest('.combo-box') || 
        e.target.closest('[is="toggle-button"][aria-controls*="combo-box"]') ||
        e.target.closest('.combo-box__close-button')) {
      setTimeout(updateComboBoxColorSwatches, 100);
    }
  });
  
  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'SELECT' && e.target.closest('.product-sticky-form')) {
      setTimeout(updateComboBoxColorSwatches, 150);
    }
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComboBoxObservers);
  } else {
    initComboBoxObservers();
  }
  
})();
